type Players = Record<string, unknown>;
type ShellResult = Record<string, { score: number }>;

// Creates a shell for aggregating results from multiple rounds of a game.
function shell(players: Players): ShellResult {
	const finalResults: ShellResult = {};
	Object.keys(players).forEach((playerId) => {
		finalResults[playerId] = { score: 0 };
	});
	return finalResults;
}

export { shell };

export default shell;
